import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import ChevronDownIcon from '@precis-digital/kurama/icons/ChevronDownIcon';
import Input from '@precis-digital/kurama/Input';
import { StyledMailInputButton, StyledMailInputWrapper } from '../Popup/styles';
import { type MemberRole } from 'shared/api/clients';
import { RoleDropdown } from './DropDownAdminInvite';
import { isValidInviteEmailFormat } from '../../utils';
interface MailInputProps {
  index: number;
  role: MemberRole;
  email: string;
  setEmail: (index: number, email: string) => void;
  setValidEmail: (index: number, valid: boolean) => void;
  duplicateEmailCheck: (email: string) => boolean;
  setRole: (index: number, role: MemberRole) => void;
  alreadyMemberEmailCheck: (email: string) => boolean;
  handleSendInvitations: () => Promise<void>;
}
export const MailInput = props => {
  const $ = _c(40);
  const {
    index,
    role,
    email,
    setEmail,
    setRole,
    setValidEmail,
    duplicateEmailCheck,
    alreadyMemberEmailCheck,
    handleSendInvitations
  } = props;
  let t0;
  if ($[0] !== alreadyMemberEmailCheck || $[1] !== duplicateEmailCheck) {
    t0 = email_0 => isValidInviteEmailFormat(email_0) && !duplicateEmailCheck(email_0) && !alreadyMemberEmailCheck(email_0);
    $[0] = alreadyMemberEmailCheck;
    $[1] = duplicateEmailCheck;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isValidEmail = t0;
  const mailInputColor = isValidEmail(email) ? "success" : "error";
  const mailHelperText = alreadyMemberEmailCheck(email) ? "You can't invite an existing member" : duplicateEmailCheck(email) ? "You can't add the same email multiple times" : undefined;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const anchorElementRef = useRef(null);
  let t1;
  if ($[3] !== email.length || $[4] !== mailInputColor) {
    t1 = email.length > 0 ? {
      color: mailInputColor
    } : null;
    $[3] = email.length;
    $[4] = mailInputColor;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== mailHelperText || $[7] !== mailInputColor) {
    t2 = mailHelperText !== undefined && {
      color: mailInputColor
    };
    $[6] = mailHelperText;
    $[7] = mailInputColor;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== handleSendInvitations) {
    t3 = e => {
      if (e.key === "Enter") {
        handleSendInvitations();
      }
    };
    $[9] = handleSendInvitations;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== index || $[12] !== isValidEmail || $[13] !== setEmail || $[14] !== setValidEmail) {
    t4 = e_0 => {
      setEmail(index, e_0.target.value);
      setValidEmail(index, isValidEmail(e_0.target.value));
    };
    $[11] = index;
    $[12] = isValidEmail;
    $[13] = setEmail;
    $[14] = setValidEmail;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== email || $[17] !== mailHelperText || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t5 = <div><Input name="Input" value={email} {...t1} helperText={mailHelperText} {...t2} onKeyDown={t3} onChange={t4} placeholder="Ex: name@example.com" /></div>;
    $[16] = email;
    $[17] = mailHelperText;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon />;
    t7 = () => {
      setDropdownOpen(true);
    };
    $[23] = t6;
    $[24] = t7;
  } else {
    t6 = $[23];
    t7 = $[24];
  }
  let t8;
  if ($[25] !== role) {
    t8 = <StyledMailInputButton rightIcon={t6} onClick={t7} scheme="light" variant="outlined">{role}</StyledMailInputButton>;
    $[25] = role;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== index || $[28] !== setRole) {
    t9 = role_0 => {
      setRole(index, role_0);
      setDropdownOpen(false);
    };
    $[27] = index;
    $[28] = setRole;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setDropdownOpen(false);
    };
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== dropdownOpen || $[32] !== t9) {
    t11 = <RoleDropdown anchorElementRef={anchorElementRef} open={dropdownOpen} onSelect={t9} onClose={t10} />;
    $[31] = dropdownOpen;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t8) {
    t12 = <div ref={anchorElementRef}>{t8}{t11}</div>;
    $[34] = t11;
    $[35] = t8;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t12 || $[38] !== t5) {
    t13 = <StyledMailInputWrapper>{t5}{t12}</StyledMailInputWrapper>;
    $[37] = t12;
    $[38] = t5;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
};